
import { Route, Switch } from 'react-router-dom';

import V2Root from '../v2/app/V2Root';

import Attributes from './attributes/Module';
import Authentication from './authentication/Module';
import Calendar from './calendar/Module';
import CardExpansions from './cardExpansions/Module';
import Cards from './cards/Module';
import Carousel from './carousel/Module';
import Carts from './carts/Module';
import Catalog from './catalog/Module';
import Categories from './categories/Module';
import CategoryLists from './categoryLists/Module';
import Dashboard from './dashboard/Module';
import EventReservations from './eventReservations/Module';
import GamesWorkshop from './gamesWorkshop/Module';
import InterestRegistrations from './interestRegistrations/Module';
import InventoryBuffer from './inventoryBuffer/Module';
import Offers from './offers/Module';
import Orders from './orders/Module';
import PaymentTypes from './paymentTypes/Module';
import Preorders from './preorders/Module';
import ProductLists from './productLists/Module';
import Products from './products/Module';
import Reports from './reports/Module';
import ScheduleProgram from './scheduleProgram/Module';
import ShipmentManifests from './shipmentManifests/Module';
import ShopSales from './shopSales/Module';
import Shops from './shops/Module';
import ShortUrls from './shortUrl/Module';
import Sidebar from './sidebar/Module';
import SingleWizard from './singleWizard/Module';
import StockAccounts from './stockAccount/Module';
import StockOperations from './stockOperations/Module';
import SupplierOrders from './supplierOrders/Module';
import Suppliers from './suppliers/Module';
import Users from './users/Module';
import Vouchers from './vouchers/Module';


import OrchestraLayout from './common/Layouts/OrchestraLayout';

const modules = [
    ...Authentication,
    <Route key="v2-mount" path="/v2" component={V2Root} />,
    <OrchestraLayout key="admin-interface-routes">
        <Switch>
            {[
                ...Carts,
                ...ShortUrls,
                ...Users,
                ...Attributes,
                ...Categories,
                ...Products,
                ...Catalog,
                ...PaymentTypes,
                ...Offers,
                ...Orders,
                ...ProductLists,
                ...Calendar,
                ...EventReservations,
                ...Carousel,
                ...Suppliers,
                ...SupplierOrders,
                ...StockOperations,
                ...CategoryLists,
                ...ShopSales,
                ...Shops,
                ...ScheduleProgram,
                ...StockAccounts,
                ...Vouchers,
                ...Preorders,
                ...CardExpansions,
                ...Cards,
                ...InventoryBuffer,
                ...InterestRegistrations,
                ...Reports,
                ...GamesWorkshop,
                ...ShipmentManifests,
                ...SingleWizard,
                ...Sidebar,
                ...Dashboard,
            ]}
        </Switch>
    </OrchestraLayout>
]

export default modules;
